<dx-popup
    #denyWorkflowPopup
    minWidth="150px"
    minHeight="70px"
    width="40%"
    height="50%"
    title="Please provide a reason"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onDenyWorkflowPopUpShown()"
    (onHidden)="onDenyWorkflowPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" labelLocation="top" [colCount]="1" [scrollingEnabled]="true">
                        <dxi-item>
                            <dxo-label text="Reason to deny this Invoice"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    class="textarea-content"
                                    [height]="110"
                                    [value]="denyWorkflowReason"
                                    [maxLength]="denyWorkflowReasonMaxLength"
                                    (onKeyUp)="onReasonValueChanged($event)"
                                ></dx-text-area>
                                <div class="text-alignment">
                                    {{ getCharacterCount() }}/{{ denyWorkflowReasonMaxLength }}
                                </div>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onDenyWorkflowPopUpClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Ok"
                                    [icon]="iconCheck"
                                    (onClick)="onDenyConfirmWorkflow()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #denyWorkflowMessageBox></cc-message-box>
